import { Position } from 'reactflow';
import { applyVueInReact } from 'vuereact-combined';

import { HiddenHandle } from './common';
import { NodeProps } from '../types';
import NotVisibleNode from '@/components/FlowTree/NotVisibleNode.vue';
import { AppPopover } from '@/react_app/components/Atoms';
const VueNotVisibleNode = applyVueInReact(NotVisibleNode);
export default function LimitedVisibilityNode({
	sourcePosition = Position.Top,
	targetPosition = Position.Bottom,
	type,
}: NodeProps & { type: 'loop' | 'branches' }) {
	return (
		<>
			<HiddenHandle type="source" position={sourcePosition} />
			<AppPopover content="Click to switch to workflow view" trigger="hover">
				<VueNotVisibleNode type={type} />
			</AppPopover>
			<HiddenHandle type="target" position={targetPosition} />
		</>
	);
}
